module.exports = __webpack_public_path__ + "assets/img/eff4b33918641dc91adb7c382f5f4166.png";